/**
 * The Change card composer's words (KPE-028, KPR-708): the sentences the row's
 * value editor, its transform dialog and its fixed value dialog say, in one
 * place so they are tested without a DOM. An element is named by its label,
 * never its stored name; sentence case, verbs on buttons, no exclamation marks
 * (docs/platform-standards.md §11).
 */

export const BUILD_VALUE = 'Build a value';
export const HIDE_VALUE = 'Use the picker';
export const INSERT_HINT = 'Add an element, a date or the person with the insert button.';
export const FIXED_VALUE = 'Set a fixed value';
export const FIXED_VALUE_APPLY = 'Use this value';
export const CANCEL = 'Cancel';
export const APPLY = 'Apply';
export const NO_TRANSFORM = 'No transform';
export const TRANSFORM_PICK = 'Transform';
export const PREVIEW_HEAD = 'For example';
export const PREVIEW_STALE = 'Out of date until the change below is worked out.';

export const composerLabel = label => `Value for ${label}`;
export const fixedTitle = label => `Fixed value for ${label}`;
export const transformTitle = label => `Change how ${label} is written`;

export const PLACEHOLDER_TEXT = 'Type words and add elements in any order';
export const PLACEHOLDER_ONE = 'Add one element, a dynamic value or a fixed value';

/** What the element takes, in one line under the editor. `typeWords` is the data type's label. */
export function expectedLine(typeWords, textual) {
	return textual
		? `${typeWords}: words and values, joined in the order shown.`
		: `${typeWords}: one value, whatever it is built from.`;
}

/** The sentence when a pill cannot take a transform (an id is never written as text). */
export const NO_TRANSFORMS_FOR_LINK = 'A link or a person is written as its title or name, so no transform applies here. Add an element of the linked item instead.';
export const NO_TRANSFORMS_UNKNOWN = 'This value is not shown on the page, so there is nothing to change here.';

/** "Ada Lovelace → ADA LOVELACE" */
export const exampleLine = (before, after) => `${before} → ${after}`;
export const EXAMPLE_NONE = 'No item in the preview holds a value to show.';
export const exampleFor = title => (title ? `Example, ${title}` : 'Example');

/** The words on the preview rows. */
export const previewRow = (title, value) => `${title || 'An item'}: ${value}`;
